import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/noto-sans-symbols-2/symbols-400.css';
import Chess from './Chess.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Chess />
  </React.StrictMode>,
);
